/* eslint-disable import/no-anonymous-default-export */

import { AxiosError } from "axios"
import moment from "moment"
import { CodigoInfraccion } from "../codigos-infraccion/hooks/useCodigosInfraccionAPI"
import useApi, { Api, Model, Query, Response } from "../common/hooks/useApi"
import { UnidadProduccion } from "../unidades-produccion/useUnidadesProduccionAPI"

export type TipoExportacion = ("NO_EXPORTA" | "PROTOCOLO_BA")

export type TipoImpresion = ("NO_IMPRIME" | "ACTA_IMPORTADA" | "TEMPLATE")

export type PlataformaPago = ("HELIPAGOS" | "EPAGOS" | "PAGOTIC");

export interface ConfiguracionProduccion extends Model {
    Nombre: string
    UnidadProduccion: UnidadProduccion
    UnidadProduccionId: number

    /* Configuración precarga */
    TipoContenedorPrecarga: string
    SftpHost: string
    SftpPuerto: string
    SftpContrasena: string
    SftpUsuario: string
    SftpRuta: string
    ContrasenaContenedor?: string

    /* Configuración infracción */
    EtiquetaCodigoInfracciones: string
    CodigoInfraccionId?: number | null
    CodigoInfraccion: CodigoInfraccion

    /* Configuración pago */
    ConfiguracionesFecha: {
        CotizacionUF: number
        PorcentajeDescuentoPagoVoluntario: number
        GastosAdministrativos: number
        DiasPagoVoluntario: number
        Dias2doVencimiento: number
        DiasDescargo: string

        LimiteFecha?: string
        Provincia?: string
        CodigoPostal?: string
    }[]

    /* Configuración exportación/impresión */
    TipoExportacion: TipoExportacion
    TipoImpresion: TipoImpresion
    TemplateImpresion?: string
    PatronCodigoBarrasCorreo?: string
    LargoMinCodigoBarrasCorreo?: number
    ValorCostoEnvio : number
    Telefono?: string
    Horarios?: string
    Email?: string
    Ley?: string
    Ordenanza?: string
    PrefijoTramite?: string
    Municipio?: string

    ExcluirPatentes?: boolean
    PatentesExcluidas: string // se tomo como referencia ClasesPermitidas de la configuracion de analitica
    CuitCuilExcluidos?: string
    ExcluirCuitCuil?: boolean
    UFVisibleMontos?: boolean
    LeyendaFirma?: string
    CantidadUFGastosAdm?: string

    /* Configuración exportación BA */
    CodigoProveedorBA?: string
    AutoridadConstatacionBA?: string
    CodigoJurisdiccionBA?: string
    CodigoPostalBA?: string
    NombreProveedorBA?: string
    NumeroExportacionInicioBA?: number
    NumeroDiaExportacionInicioBA?: number
    NumeroInfraccionExportacionInicioBA?: number

    /* Configuración API Pago */
    PlataformaPago: PlataformaPago
    BearerHelipagos?: string
    ApiKeyHelipagos?: string
    UrlApi?: string
    IdOrganismoEpagos?: string
    TipoOperacionEpagos?: string
    IdUsuarioEpagos?: string
    HashEpagos?: string
    PasswordEpagos?: string
    ConvenioEpagos?: string
    DescripcionSolicPago?: string
}

export interface ConfiguracionProduccionForm extends Omit<Partial<ConfiguracionProduccion>, 'ConfiguracionesFecha' | 'PatentesExcluidas' | 'CuitCuilExcluidos'> {
    ConfiguracionesFecha?: {
        CotizacionUF?: number
        PorcentajeDescuentoPagoVoluntario?: number
        GastosAdministrativos?: number
        DiasPagoVoluntario?: number
        Dias2doVencimiento?: number
        DiasDescargo?: string

        LimiteFecha?: moment.Moment
        Provincia?: string
        CodigoPostal?: string
    }[]
    PatentesExcluidas?: {Nombre: string}[]
    CuitCuilExcluidos?: {Nombre: string}[]
}

export interface ConfiguracionProduccionSave extends Omit<Partial<ConfiguracionProduccion>, 'ConfiguracionesFecha'> {
    ConfiguracionesFecha?: string
}

export interface TipoContenedorPrecarga {
    nombre: string,
    id: string
}

export default () => {
    const module = "ConfiguracionProduccion";
    const api = useApi({ module });

    return {
        list: (query: Query) => api.list!<ConfiguracionProduccion>(query),
        save: (data: ConfiguracionProduccionSave) => api.save!<ConfiguracionProduccionSave, ConfiguracionProduccion>(data),
        delete: (id: number) => api.delete!<ConfiguracionProduccion>(id),
        listTiposContenedorPrecarga: async () => {
            try {
                const response = await api.axiosInstance.get<Response<TipoContenedorPrecarga[]>>(`TipoContenedorPrecarga`);
                return {
                    data: response.data
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        listTemplatesImpresion: async () => {
            try {
                const response = await api.axiosInstance.get(`${module}/getTemplates`);
                return {
                    data: response.data
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        }
    };
}